var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"laws"}},[_c('section',[_c('lawsmenu')],1),_c('section',[_c('lawsjxflzs')],1),_c('section',[_c('lawsifynew')],1),_c('section',[_c('lawsjxlmtj')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }